export default __webpack_public_path__ + "static/media/illustration-recruit-4-m.a0dd4398.webp";